export default __webpack_public_path__ + "static/media/eth-todo-blog.69010402.svg";